import AppSidebar from './AppSidebar';
import { SidebarTrigger } from './components/Sidebar';

export { SidebarTrigger };
export default AppSidebar;
